// Utility functions for the organization app

export function classNames(
  ...classes: (string | undefined | null | false)[]
): string {
  return classes.filter(Boolean).join(" ")
}

/**
 * Format a cent-based amount as a USD currency string.
 * @param amount - Amount in cents (e.g. 5000 = $50.00). Null/undefined returns "$0.00".
 */
export function formatCurrency(amount: number | null | undefined): string {
  if (amount == null) return "$0.00"
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount / 100)
}
